import React from "react";


const PartSuggestionForm = ({ onSubmit }) => (
    <div className="parts-other" dir="rtl">
        <span className="parts-other__label">أخرى</span>
        <form
            className="parts-other__form"
            onSubmit={async (e) => {
                e.preventDefault();
                const formEl = e.currentTarget;
                const input = formEl.elements.namedItem("otherPart");
                const value = typeof input?.value === "string" ? input.value.trim() : "";
                if (!value) {
                    alert("⚠️ الرجاء إدخال اسم القطعة.");
                    return;
                }
                const ok = await onSubmit(value);
                if (ok) formEl.reset();
            }}
        >
            <input
                name="otherPart"
                type="text"
                className="parts-other__input"
                placeholder="إذا ما حصلت طلبك، اكتب اسم القطعة اللي تحتاجها..."
            />
            <button type="submit" className="parts-other__btn">إرسال</button>
        </form>
    </div>
);


export default PartSuggestionForm;